<template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <canvas ref="chartCanvas" :width="width" :height="height"></canvas>
    </v-card-text>
  </v-card>
</template>

<script>
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, PieController } from 'chart.js';

// Registrar el PieController para que Chart.js lo reconozca
ChartJS.register(Title, Tooltip, Legend, ArcElement, PieController);

export default {
  name: 'TimeLeft',
  props: {
    title: {
      type: String,
      required: true
    },
    startDate: {
      type: String,
      required: true
    },
    endDate: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    }
  },
  data() {
    return {
      timeLeftChart: null,
      chartData: {
        labels: ['Tiempo Transcurrido', 'Tiempo Restante'],
        datasets: [
          {
            backgroundColor: ['#FF6384', '#36A2EB'],
            data: [],
          }
        ]
      }
    };
  },
  watch: {
    startDate: 'fetchData',
    endDate: 'fetchData'
  },
  methods: {
    calculateTimeLeft() {
      if (!this.startDate || !this.endDate) {
        console.error('Fechas del proyecto no encontradas');
        return;
      }

      const startDate = new Date(this.startDate);
      const endDate = new Date(this.endDate);
      const currentDate = new Date();

      const totalTime = endDate - startDate;
      const elapsedTime = currentDate - startDate;
      const remainingTime = endDate - currentDate;

      if (remainingTime < 0) {
        this.chartData.datasets[0].data = [totalTime, 0];
      } else {
        this.chartData.datasets[0].data = [elapsedTime, remainingTime];
      }
    },
    createChart() {
      if (!this.$refs.chartCanvas) {
        return;
      }

      const ctx = this.$refs.chartCanvas.getContext('2d');

      if (!ctx) {
        return;
      }

      // Destruir el gráfico anterior si existe
      if (this.timeLeftChart) {
        this.timeLeftChart.destroy();
      }

      this.timeLeftChart = new ChartJS(ctx, {
        type: 'pie',
        data: this.chartData,
        options: {
          responsive: false,
          maintainAspectRatio: false,
        },
      });
    },
    fetchData() {
      this.calculateTimeLeft();
      this.createChart();
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style scoped>
.v-card {
  max-width: 600px;
  margin: 20px auto;
}

.v-card-text {
  height: 100%;
}
</style>
